import React, { useEffect, useState } from "react";
import { ButtonFilled, ButtonOutlined } from "reusableComponent/UIButtons";
import { Form, Input, message, Modal } from "antd";
import styled from "@emotion/styled";
import { STATUS_CODE } from "common/Constants";
import { CALL_API } from "common/API";
import { connect } from "react-redux";
import { getClientid } from "redux/selectors";
import { useTranslation } from "react-i18next";

const StyledModal = styled(Modal)`
  border-radius: 10px;
  padding-top: 5%;
  p {
    font-size: 18px;
    color: black;
    font-weight: 600;
  }
  .ant-modal-content {
    border-radius: 10px;
  }
  .ant-modal-close-x {
    padding-top: 10px;
  }
  .ant-modal-footer {
    display: none;
  }
  .stylebtn {
    min-width: 130px;
  }
  .ant-modal-body {
    padding: 24px 24px 0px 24px;
  }
`;

function EditAvailableCount({
  clientId,
  userId,
  leaveId,
  leaveTypeName,
  isModalOpen,
  handleCancel,
  name,
  leaveAvailable,
  getUserLeaveData,
}) {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [btnLoader, setBtnLoader] = useState(false);

  useEffect(() => {
    if (isModalOpen) {
      form.setFieldsValue({
        leaveType: leaveTypeName,
        availableCount: leaveAvailable,
      });
    }
  }, [isModalOpen, leaveTypeName, leaveAvailable, form]);

  const closeModal = () => {
    handleCancel();
    form.resetFields();
  };

  const handleSubmit = async (value) => {
    setBtnLoader(true);
    try {
      const { code, error } = await CALL_API(
        `employee-leave-details/${clientId}`,
        "patch",
        {
          userId: userId,
          leaveType: leaveId,
          availableCount: Number(value?.availableCount),
          year: new Date().getFullYear(),
        }
      );
      if (code === STATUS_CODE.SUCCESS) {
        message.success(t("Leave count updated successfully"));
        closeModal();
        getUserLeaveData();
      } else {
        message.error(error || t("Something went wrong"));
      }
    } catch (err) {
      message.error(t("Something went wrong"));
    } finally {
      setBtnLoader(false);
    }
  };

  return (
    <StyledModal
      title=""
      open={isModalOpen}
      onCancel={closeModal}
      footer={[]}
      destroyOnClose
    >
      <p>{name}</p>

      <Form
        form={form}
        name="editavailablecountform"
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item name="leaveType" label={t("Leave Type")}>
          <Input disabled />
        </Form.Item>
        <Form.Item
          name="availableCount"
          label={t("leave.available_leave_count")}
          rules={[
            {
              validator: (_, value) => {
                if (value === undefined || value === null || value === "") {
                  return Promise.reject(
                    new Error(t("Available count is required"))
                  );
                }
                if (isNaN(Number(value)) || Number(value) < 0) {
                  return Promise.reject(
                    new Error(t("Please enter a valid count"))
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input
            placeholder={t("leave.available_leave_count")}
            maxLength={5}
            onKeyDown={(e) => {
              const allowedChars = /^[0-9.]$/;
              const specialKeys = [
                "Backspace",
                "ArrowLeft",
                "ArrowRight",
                "Delete",
                "Tab",
              ];
              if (!allowedChars.test(e.key) && !specialKeys.includes(e.key)) {
                e.preventDefault();
              }
            }}
          />
        </Form.Item>
        <div className="text-end mb-3">
          <ButtonOutlined key="back" onClick={closeModal} className="stylebtn">
            Cancel
          </ButtonOutlined>
          <ButtonFilled
            key="submit"
            loading={btnLoader}
            className="stylebtn"
            htmlType="submit"
          >
            {t("Update")}
          </ButtonFilled>
        </div>
      </Form>
    </StyledModal>
  );
}
const mapStateToProps = (state) => ({
  clientId: getClientid(state),
});
export default connect(mapStateToProps, null)(EditAvailableCount);
